import WrapperService from '@/modules/core/services/wrapper-service';
import {createPageableParams} from "@/modules/core/services/table-utils";
const API_URL = process.env.VUE_APP_ROOT_API + '/api/v1/global-documentation';

const serviceName = "Global-Documentation-Service: ";
export default class GlobalDocumentationService {

  static async createOrSaveGlobalContract(contract, facilityList, file, successF, errorF) {
    let formData = new FormData();

    if (file && file.name) {
      formData.append("document", file, file.name);
    }

    formData.append("contractInfo", JSON.stringify(contract));
    formData.append("facilityIds",facilityList);
    if (contract.id) {
      await WrapperService.put(API_URL + '/contract', formData, serviceName, successF, errorF);
    } else {
      await WrapperService.post(API_URL + '/contract', formData, serviceName, successF, errorF);
    }
  }

  static async getFacilityBuildInfo(documentationId, successF, errorF) {
    await WrapperService.get(API_URL + '/contract-info/' + documentationId, null, serviceName, successF, errorF);
  }

  static async deleteGlobalContract(contractId, successF, errorF) {
    await WrapperService.delete(API_URL + '/contract/' + contractId, null, serviceName, successF, errorF);
  }

  static async readPageableDocumentationsFromAPI(page, size, search, sort, sortAsc, filter, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], []);

    if (filter && filter.customer) {
      params.append('customer', filter.customer);
    }

    await WrapperService.get(API_URL + '/documentations', { params: params}, serviceName, successF, errorF);
  }
  static async saveOrUpdateGlobalDocumentation(documentation, file, facilityIds, successF, erroF) {
    let formData = new FormData();

    if (file && file.name) {
      formData.append("documentFile", file, file.name);
    }

    formData.append("documentation", JSON.stringify(documentation));
    formData.append("facilityIds", facilityIds);

    if (documentation.id) {
      await WrapperService.put(API_URL + '/update/documentation', formData, serviceName, successF, erroF);
    } else {
      await WrapperService.post(API_URL + '/create/documentation', formData, serviceName, successF, erroF);
    }
  }

  static async deleteGlobalDoc(documentationId, successF, errorF){
    await WrapperService.delete(API_URL + '/delete/documentation/' + documentationId, serviceName, successF, errorF);
  }
}